// extracted by mini-css-extract-plugin
export default {"header":"OutsideLiens_header__kQDUh","practice_amount":"OutsideLiens_practice_amount__i4ddz","total":"OutsideLiens_total__Q6Nml","value":"OutsideLiens_value__J32CH"};